import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Observable, combineLatest, map} from 'rxjs';
import {ConnectionStatusCheckerService} from '../connection-status-checker.service';
import { AsyncPipe } from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {AuthenticationService} from '@services/authentication.service';
import {MatIconModule} from '@angular/material/icon';
import {MatSnackBar} from '@angular/material/snack-bar';
import {skip} from 'rxjs/operators';

enum ApplicationStatus {
  OFFLINE,
  AUTH_REFRESH_ERROR,
  STABLE
}

@Component({
    selector: 'app-connection-status',
    templateUrl: './connection-status.component.html',
    styleUrls: ['./connection-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, MatButtonModule, MatIconModule]
})
export class ConnectionStatusComponent implements OnInit {
  private isOffline$: Observable<boolean>;
  private authRefreshError$: Observable<boolean>;
  applicationStatus$: Observable<ApplicationStatus>;
  ApplicationStatus = ApplicationStatus;

  constructor(
    private connectionHandlerService: ConnectionStatusCheckerService,
    private authenticationService: AuthenticationService,
    private matSnackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.isOffline$ = this.connectionHandlerService.isOffline$;
    this.authRefreshError$ = this.authenticationService.authRefreshError$;

    this._handleSnackbar();
    this._handlePopup();
  }

  private _handleSnackbar() {
    this.isOffline$.pipe(
      skip(1)
    ).subscribe(isOffline => {
      if (isOffline) {
        this.matSnackBar.open('Pas de connexion internet!', '');
      }
      else {
        this.matSnackBar.open('Connexion rétablie!', '', {duration: 2000});
      }
    });
  }

  private _handlePopup() {
    this.applicationStatus$ = combineLatest([
      this.isOffline$, this.authRefreshError$
    ]).pipe(
      map(([isOffline, authRefreshError]) => {
        console.log({
          isOffline,
          authRefreshError
        })
        if (isOffline) {
          return ApplicationStatus.OFFLINE;
        }
        else if (authRefreshError) {
          return ApplicationStatus.AUTH_REFRESH_ERROR;
        }
        return ApplicationStatus.STABLE;
      })
    );
  }

  reload() {
    window.location.reload();
  }
}
